import ForgotPassword from '../modules/login/forgotPassword';
import Login from '../modules/login';
import ResetPassword from '../modules/login/resetPassword';
import { RouteType } from './routeType';

export const loginRoute: RouteType = {
  path: 'login',
  name: 'login',
  component: Login,
  layout: '/',
  isPrivate: false,
  roles: [],
};

export const forgotPasswordRoute: RouteType = {
  path: 'recuperarsenha',
  name: 'Recuperar senha',
  component: ForgotPassword,
  layout: '/',
  isPrivate: false,
  roles: [],
};

export const newPasswordRoute: RouteType = {
  path: 'novasenha',
  name: 'Nova senha',
  component: Login,
  layout: '/',
  isPrivate: false,
  roles: [],
};

export const changePasswordRoute: RouteType = {
  path: 'trocarsenha',
  name: 'Trocar senha',
  component: Login,
  layout: '/',
  isPrivate: false,
  roles: [],
};

export const resetPasswordRoute: RouteType = {
  path: 'resetarsenha',
  name: 'Resetar senha',
  component: ResetPassword,
  layout: '/',
  isPrivate: false,
  roles: [],
};
